import Router from 'vue-router';
import configurationRoute from '@/router/configuration';
import login from './login';
import polls from './polls';
import diagnosis from './diagnosis';
import jobevalution from '../modules/job-evaluation/router';
import user from './user';
import awardsRoute from './awards';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				component: () => import('@/pages/page-home'),
				redirect: 'working-environment',
				meta: {
					title: 'Clima Laboral',
				},
				children: [
					{
						name: 'working-environment',
						path: 'working-environment',
						component: () => import('@/pages/working-environment/page-working-environment'),
						redirect: 'working-environment/surveys',
						meta: {
							title: 'Clima Laboral',
						},
						props: true,
						children: [
							{
								name: 'working-environment-surveys',
								path: 'surveys',
								component: () => import('@/pages/working-environment/page-surveys'),
								meta: {
									title: 'Clima Laboral',
								},
								children: [
									{
										name: 'working-environment-surveys-new',
										path: 'new',
										component: () => import('@/pages/working-environment/page-surveys-new'),
										meta: {
											title: 'Clima Laboral',
										},
									},
								],
							},
						],
					},
					{
						name: 'organizational-diagnosis',
						path: 'organizational',
						component: () => import('@/pages/organizational/page-organizational'),
						meta: {
							title: 'Diagnóstico Organizacional Praktiko',
						},
						props: true,
						children: [
							{
								name: 'surveys-organizational-diagnosis',
								path: 'surveys',
								component: () => import('@/pages/organizational/page-surveys'),
								meta: {
									title: 'Diagnóstico Organizacional Praktiko',
								},
							},
							{
								name: 'new-organizational-diagnosis',
								path: 'new',
								component: () => import('@/pages/organizational/page-new-surveys'),
								meta: {
									title: 'Diagnóstico Organizacional Praktiko',
								},
							},
						],
					},
					{
						name: 'culture-inventory',
						path: 'inventory',
						component: () => import('@/pages/inventory/page-inventory'),
						meta: {
							title: 'Inventario de Cultura Organizacional',
						},
						props: true,
						children: [
							{
								name: 'surveys-inventory',
								path: 'surveys',
								component: () => import('@/pages/inventory/page-surveys-inventory'),
								meta: {
									title: 'Inventario de Cultura Organizacional',
								},
							},
							{
								name: 'new-inventory',
								path: 'new-surveys',
								component: () => import('@/pages/inventory/page-new-surveys-inventory'),
								meta: {
									title: 'Inventario de Cultura Organizacional',
								},
							},
						],
					},
					diagnosis,
					polls,
					configurationRoute,
					jobevalution,
					user,
					awardsRoute,
				],
			},
			{
				path: '/reset-password',
				name: 'reset-password',
				meta: {
					title: 'Recuperar Contraseña',
				},
				component: () => import('@/pages/page-reset-password'),
			},
			login,
		],
	});
	config.beforeEach((to, from, next) => {
		if (to.name !== 'login') {
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token || to.name === 'reset-password') {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js